declare namespace $ {

	type $shm_hitalama_hovered__hovered_shm_hitalama_draglist_item_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_draglist_item['hovered'] >
		,
		ReturnType< $shm_hitalama_hovered['hovered'] >
	>
	export class $shm_hitalama_draglist_item extends $rise_drag_absolute {
		transition( ): string
		hovered( next?: boolean ): boolean
		Hovered( ): $shm_hitalama_hovered
		click( next?: any ): any
		transition_smooth( ): string
		style( ): ({ 
			'transition': ReturnType< $shm_hitalama_draglist_item['transition'] >,
		})  & ReturnType< $rise_drag_absolute['style'] >
		plugins( ): readonly(any)[]
		event( ): ({ 
			click( next?: ReturnType< $shm_hitalama_draglist_item['click'] > ): ReturnType< $shm_hitalama_draglist_item['click'] >,
		}) 
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map